import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import { ApolloProvider } from 'react-apollo';
import ApolloClient from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
// import { setContext } from 'apollo-link-context';
import { withClientState } from 'apollo-link-state';
import { ApolloLink } from 'apollo-link';


import './Assets/css/style.css';
import './Assets/lib/material-design-icons/css/material-design-iconic-font.min.css';
import './Assets/css/mdi.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { defaults, resolvers } from './localResolvers/resolvers';

const cache = new InMemoryCache();

// const httpLink = createHttpLink({ uri: 'http://localhost:4000' });
const httpLink = createHttpLink({ uri: 'https://graphql.winternet.work' });
// const httpLink = createHttpLink({ uri: 'https://backendstaging.winternet.work' });

const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      "Authorization": 'Bearer ' + localStorage.getItem('token') || null
    }
  });
  console.log('Set context:');
  return forward(operation);
});

const newLink = middlewareLink.concat(httpLink);

// const stateLink = withClientState({
//   cache,
//   resolvers,
//   defaults
// });

const stateLink = withClientState({
  cache,
  defaults,
  resolvers
});

const newLinkWithState = ApolloLink.from([stateLink, newLink]);



const client = new ApolloClient({
  // link: authLink.concat(httpLink), this one did not work
  // link: newLink,  //this one worked
  link: newLinkWithState, //testing apollo-link-state
  cache: cache,
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>
  , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js